import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Box, Button, Typography, Stepper, Step, StepLabel, TextField, Select, MenuItem, OutlinedInput, Chip, Alert, Grid } from '@mui/material';

// Importiamo i componenti dei form che definiremo sotto
import { StudentForm } from './StudentForm';
import { BusinessForm } from './BusinessForm';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 600,
  bgcolor: 'background.paper',
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
};

const SignupModal = ({ open, onClose, onRegisterSuccess }) => {
  const [userType, setUserType] = useState(null); // 'student' o 'business'

  const handleClose = () => {
    onClose();
    setTimeout(() => setUserType(null), 300); // Resetta la scelta alla chiusura
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        {!userType ? (
          // --- VISTA INIZIALE DI SCELTA ---
          <>
            <Typography variant="h5" textAlign="center" gutterBottom>Registrati Come</Typography>
            <Grid container spacing={2} sx={{ mt: 3 }}>
              <Grid item xs={12} sm={6}>
                <Button fullWidth variant="outlined" size="large" onClick={() => setUserType('student')} sx={{ p: 3 }}>
                  Studente / Alunno
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button fullWidth variant="outlined" size="large" onClick={() => setUserType('business')} sx={{ p: 3 }}>
                  Azienda Partner
                </Button>
              </Grid>
            </Grid>
          </>
        ) : userType === 'student' ? (
          // --- FORM PER LO STUDENTE ---
          <StudentForm onRegisterSuccess={onRegisterSuccess} />
        ) : (
          // --- FORM PER L'AZIENDA ---
          <BusinessForm onRegisterSuccess={onRegisterSuccess} />
        )}

        {userType && (
            <Button onClick={() => setUserType(null)} sx={{ mt: 2 }}>
                Indietro
            </Button>
        )}
      </Box>
    </Modal>
  );
};

export default SignupModal;